import browser from "webextension-polyfill";
export async function send(type, args = {}) {
    return await browser.runtime.sendMessage({ ...args, type });
}
